/**
 * Product Tabs Component
 * Handles tab switching functionality
 */

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    
    this.buttons = this.querySelectorAll('.product-tabs__nav-button');
    this.contents = this.querySelectorAll('.product-tabs__content');
    
    this.init();
  }
  
  init() {
    // Add click event listeners to all tab buttons
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => this.switchTab(e));
    });
    
    // Set first tab as active by default if none are active
    const hasActiveTab = Array.from(this.buttons).some(btn => 
      btn.classList.contains('active')
    );
    
    if (!hasActiveTab && this.buttons.length > 0) {
      this.buttons[0].classList.add('active');
      if (this.contents.length > 0) {
        this.contents[0].classList.add('active');
      }
    }
  }
  
  switchTab(event) {
    const clickedButton = event.currentTarget;
    const targetTab = clickedButton.dataset.tab;
    
    // Remove active class from all buttons and contents
    this.buttons.forEach(btn => btn.classList.remove('active'));
    this.contents.forEach(content => content.classList.remove('active'));
    
    // Add active class to clicked button
    clickedButton.classList.add('active');
    
    // Show corresponding content
    const targetContent = this.querySelector(`[data-tab-content="${targetTab}"]`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
    
    // Optional: Track analytics
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'product_tab_switch',
        tab_name: targetTab
      });
    }
  }
}

// Register custom element
if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
